import React, { Component } from 'react';
import * as ActionElements from '../../action-elements/index';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toJS } from '../../../containers/to-js';
import { getWorkflowFromCode } from '../../../actions/workflows';
import confirm from '../../commons/confirm/index';
import { toast } from 'react-toastify';
import { messages } from '../../../dto/user-messages';
import { ModelPropertiesParser } from '../../commons/modelPropertiesParser';
import moment from 'moment';
import FullScreenLoader from './FullScreenLoader';

class ActionElement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            workflowId: null,
            hide: true,
            showToast: false
        }
        this.callRules = this.callRules.bind(this)
    }
    componentDidMount() {
        const { workflow: { sessionId }, getWorkflowFromCode, invokeActionRules, action: { actionProperties: { workflow, inlineActionPlacement }, connector } } = this.props;
        //TODO: Need the below if... commenting it for now to try and remove async
        /*if (connector && connector.rules && connector.rules.length) {
            const self = this;
            if (inlineActionPlacement === 'INLINE') {
                if (!this.allMatch(connector.rules, this.props)) {
                    self.setState({ hide: true });
                } else {
                    self.setState({ hide: false });
                }
            } else {
                invokeActionRules({
                    connectorId: connector.id,
                    sessionId
                }).then(rules => {
                    if (rules.data) {
                        self.setState({ hide: !rules.data.data });
                    }
                });
            }
        } else {
            this.setState({ hide: false });
        }*/
        this.callRules(connector, inlineActionPlacement, sessionId, invokeActionRules, this.props)

        if (this.resolveExternal()) {
            getWorkflowFromCode(workflow).then((res) => {
                const workflowId = res.data.data;
                this.setState({ workflowId });
            });
        }
    }

    allMatch(rules, props) {
        for (var rule in rules) {
            if (!this.ruleMatch(rules[rule], props))
                return false;
        }
        return true;
    }

    ruleMatch(rule, props) {
        const { user } = this.props;
        var operator = rule.operator ? rule.operator : '';
        let chkParamRule = false
        if (rule && rule.resolveSession && rule.sessionParamCode == "HasRoleSessionParam") {
            chkParamRule = true;
            const userPermission = user && user.user && user.user.permissions;
            let staticValue = rule.value && rule.value.staticValue;
            let found = false;
            if (staticValue.indexOf('|') != -1) {
                staticValue = staticValue.split('|');
                found = userPermission && userPermission.find(element => staticValue.includes(element));
            } else {
                found = userPermission && userPermission.find(element => staticValue == element);
            }

            if (found) {
                return true;
            }
        }
        if (!chkParamRule) {
            switch (operator.toUpperCase()) {
                case 'IN':
                    return this.matchIn(rule, props);
                case 'NOTIN':
                    return !this.matchIn(rule, props);
                case 'EQUALS':
                    return this.match(rule, props);
                case 'NOTEQUALS':
                    return !this.match(rule, props);
                case 'LIKE':
                    return this.include(rule, props);
                case 'NOTLIKE':
                    return !this.include(rule, props);
                case 'NOTNULL':
                    return !this.match(rule, props);
                case 'ISNULL':
                    return this.match(rule, props);
                case 'LESSTHAN':
                    return this.compare(rule, props);
                case 'GREATERTHAN':
                    return !this.compare(rule, props);
                default:
                    return true;
            }
        }
    }

    matchIn(rule, props) {
        // const { workflow: { currentItem: { typeModel: name }, workflowData: { __ADDITIONAL_MODEL_DATA } }, row } = props;
        // const rightModelName = rule.value.typeModelName;
        // const leftObjId = row.id;
        // const rightObj = rightModelName === name ? props.workflowData : __ADDITIONAL_MODEL_DATA[rightModelName];
        // const rightObjCollection = rightObj && rightObj[rule.value.property];
        // if (!rightObjCollection || !rightObjCollection.length) return false;
        // for (var key in rightObjCollection) {
        //     var obj = rightObjCollection[key];
        //     if (obj.id === leftObjId) return true;
        // }
        // return false;

        const { workflow: { currentItem: { typeModel: name } }, row, workflowData, user } = props;
        const _workflowData = workflowData ? workflowData : props.wfData
        const rightModelName = rule.value && rule.value.typeModelName;
        let staticValue = rule.value && rule.value.staticValue;
        let value = ''
        if (rule.key.staticValue) {
            value = rule.key ? (row ? ModelPropertiesParser(rule.key.staticValue, row) : _workflowData ? ModelPropertiesParser(rule.key.staticValue, _workflowData) : null) : null;
        } else {
            value = rule.key ? (row ? row[rule.key.property] : _workflowData ? _workflowData[rule.key.property] : null) : null;
        }

        if (typeof value === 'undefined' || value === null) {
            if (rule.operator === 'IsNull') return true;
            return false;
        }
        if (!staticValue){
            if(rightModelName){
                staticValue = row ? row[rule.value.property] : _workflowData ? _workflowData[rule.value.property] : null
            }
        }
        if (!staticValue) return false;
        if (staticValue.indexOf('currentdate') != -1) {
            staticValue = new moment().format('YYYY-MM-DD');
            value = new moment(value).format('YYYY-MM-DD');
        } else {
            staticValue = staticValue.indexOf('{{') == -1 ? staticValue : this.resolveStaticValue(staticValue, user);
        }

        let matched = false;
        let propertiesToMatch = staticValue.replace(/ /g,'');
        console.log("Before", propertiesToMatch, value)
        propertiesToMatch = propertiesToMatch.split(",");
        value = value.replace(/ /g,'');
        console.log("After", propertiesToMatch, value);    
        value = value.split('|') ;   
        Array.isArray(propertiesToMatch) && propertiesToMatch.map((p, index) => {
            const f = value.find(e => e == p)
            if(f) {
                matched = true;
            }
        })
        if (matched) {
            return true;
        }
        return false;
    }

    match(rule, props) {
        const { workflow: { currentItem: { typeModel: name } }, row, workflowData, user } = props;
        const _workflowData = workflowData ? workflowData : props.wfData
        const rightModelName = rule.value && rule.value.typeModelName;
        let staticValue = rule.value && rule.value.staticValue;
        let value = ''
        if (rule.key.staticValue) {
            value = rule.key ? (row ? ModelPropertiesParser(rule.key.staticValue, row) : _workflowData ? ModelPropertiesParser(rule.key.staticValue, _workflowData) : null) : null;
        } else {
            value = rule.key ? (row ? row[rule.key.property] : _workflowData ? _workflowData[rule.key.property] : null) : null;
        }

        if (typeof value === 'undefined' || value === null) {
            if (rule.operator === 'IsNull') return true;
            return false;
        }
        if (!staticValue) return false;
        if (staticValue.indexOf('currentdate') != -1) {
            staticValue = new moment().format('YYYY-MM-DD');
            value = new moment(value).format('YYYY-MM-DD');
        } else {
            staticValue = staticValue.indexOf('{{') == -1 ? staticValue : this.resolveStaticValue(staticValue, user);
        }
        if (staticValue == value) {
            return true;
        }
        return false;
    }
    include(rule, props) {
        const { workflow: { currentItem: { typeModel: name } }, row, workflowData, user } = props;
        const rightModelName = rule.value.typeModelName;
        let staticValue = rule.value.staticValue;
        if (!staticValue) return false;
        staticValue = staticValue.indexOf('{{') == -1 ? staticValue : this.resolveStaticValue(staticValue, user);
        const value = rule.key ? (row ? row[rule.key.property] : workflowData ? workflowData[rule.key.property] : null) : null;
        if (value && value.includes(staticValue)) {
            return true;
        }
        return false;
    }

    compare(rule, props) {
        const { workflow: { currentItem: { typeModel: name } }, row, workflowData, user } = props;
        const _workflowData = workflowData ? workflowData : props.wfData
        const rightModelName = rule.value && rule.value.typeModelName;
        let staticValue = rule.value && rule.value.staticValue;
        let value = '';
        let compareValue = '';
        if (rule.key.staticValue) {
            value = rule.key ? (row ? ModelPropertiesParser(rule.key.staticValue, row) : _workflowData ? ModelPropertiesParser(rule.key.staticValue, _workflowData) : null) : null;
        } else {
            value = rule.key ? (row ? row[rule.key.property] : _workflowData ? _workflowData[rule.key.property] : null) : null;
        }

        if (typeof value === 'undefined' || value === null) {
            return false;
        }
        if (!staticValue) return false;
        if (staticValue.indexOf('currentdate') != -1) {
            compareValue = new moment(new moment().format('YYYY-MM-DD'));
            value = new moment(new moment(value).format('YYYY-MM-DD'));
        } else {
            compareValue = staticValue.indexOf('{{') == -1 ? staticValue : this.resolveStaticValue(staticValue, user);
        }
        if (staticValue.indexOf('currentdate') != -1) {
            if(value.diff(compareValue) < 0){
                return true;
            }
        } else if (compareValue > value) {
            return true;
        }
        return false;
    }

    resolveStaticValue(staticValue, user) {
        staticValue = ModelPropertiesParser(staticValue, user);
        return staticValue;
    }

    componentWillReceiveProps(nextProps) {
        const { actionState, clearActionTriggeredState,companyDetails, action: { actionProperties: { actionSuccessMessage, inlineActionPlacement }, connector },
            workflow: { sessionId }, invokeActionRules } = nextProps;
             const actionPermssionError = companyDetails && companyDetails.data && companyDetails.data.companySettings && companyDetails.data.companySettings.actionPermssionError
             const actionMessageSuccess = companyDetails && companyDetails.data && companyDetails.data.companySettings && companyDetails.data.companySettings.actionMessageSuccess
  
        const { showToast } = this.state;
        if (actionState && !actionState.isLoading && showToast) {
            if (!actionState.hasError) {
                toast.success(actionSuccessMessage ? actionSuccessMessage :actionMessageSuccess ? actionMessageSuccess : messages.defaultSuccessMessage);
            }
            else {
                toast.error(actionPermssionError ? actionPermssionError: messages.defaultActionErrorMessage);
            }
            this.setState({ showToast: false });
            clearActionTriggeredState(nextProps.action);
        }
        this.callRules(connector, inlineActionPlacement, sessionId, invokeActionRules, nextProps)
    }

    callRules(connector, inlineActionPlacement, sessionId, invokeActionRules, props) {
        if (connector && connector.rules && connector.rules.length) {
            if (inlineActionPlacement === 'INLINE') {
                if (!this.allMatch(connector.rules, props)) {
                    this.setState({ hide: true });
                } else {
                    this.setState({ hide: false });
                }
            } else {
                invokeActionRules({
                    connectorId: connector.id,
                    sessionId
                }).then(rules => {
                    if (rules.data) {
                        this.setState({ hide: !rules.data.data });
                    }
                });
            }
        } else {
            this.setState({ hide: false });
        }
    }
    resolveExternal() {
        const { action: { actionType, actionProperties: { displayMode } }, workflow } = this.props;
        let openInExternal = false;
        // if (actionType === 'SubWorkflow') {
        //     openInExternal = workflow.displayMode !== 'DEFAULT' && workflow.displayMode !== displayMode;
        // }
        return openInExternal;
    }
    checkBeforeTriggering() {
        const { triggerAction, action: { code } } = this.props;
        if (code === 'DeleteActionProcessor') {
            this.confirmDelete();
        }
        else {
            triggerAction();
        }

    }
    confirmDelete() {
        const { triggerAction, workflow: { currentItem: { typeModel: { name } } } } = this.props;
        const deleteOptions = {
            heading: `Delete ${name}`,
            proceed: {
                text: 'Delete',
                iconClass: 'fa fa-trash',
                color: 'danger'
            }
        }
        confirm('Are you sure you want to delete this record?', deleteOptions).then(
            (ev) => {
                this.props.triggerAction();
                this.setState({ showToast: true });
                // window.location.reload()
            },
            (ev) => { }
        )
    }
    render() {
        const { action, triggerAction, workflow, actionState, workflowData, customIcons, wfData, showAsPlaneText } = this.props;
        const { actionProperties: { elementType, hideInWeb } } = action;
        const { workflowId } = this.state;
        const Element = ActionElements[elementType || 'BUTTON'];
        if (hideInWeb) return null;
        if (this.state.hide) return null;
        if (this.resolveExternal()) {
            const navigateTo = this.context.router.route.match.path.replace(':id', workflowId);
            return <ActionElements.EXTERNAL_LINK
                action={action}
                navigateTo={navigateTo}
            />
        }
        return (
            <React.Fragment>
                <FullScreenLoader show={actionState && actionState.isLoading} />
            <Element wfData={wfData} showAsPlaneText={showAsPlaneText} actionState={actionState} customIcons={customIcons} action={action} triggerAction={this.checkBeforeTriggering.bind(this)} workflow={workflow} workflowData={workflowData} />
       </React.Fragment>
        );
    }
}

ActionElement.contextTypes = {
    router: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.get('user')
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getWorkflowFromCode: (code) => {
            return dispatch(getWorkflowFromCode(code));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ActionElement));